import { EXTERNAL_APP_ORIGIN } from '../constants/urls';

export const handleIframeMessage = (event, navigate) => {
  // Verify the message is from our iframe
  if (event.origin !== EXTERNAL_APP_ORIGIN) return;

  const { type, path } = event.data;
  
  if (type === 'NAVIGATION_CHANGE') {
    // Extract the path and map specific routes
    let newPath = path.replace(EXTERNAL_APP_ORIGIN, '');
    if (newPath === '/capabilities') {
      newPath = '/';
    } else if (newPath === '/dashboard') {
      newPath = '/samarth/dashboard';
    }
    navigate(newPath, { replace: true });
  } else if (type === 'LOGOUT_REQUEST') {
    // Handle logout request from external app
    if (typeof window.handleLogout === 'function') {
      window.handleLogout();
    }
  }
};

export const injectNavigationListener = (iframeRef) => {
  try {
    const iframeWindow = iframeRef.current.contentWindow;
    iframeWindow.addEventListener('popstate', () => {
      iframeWindow.postMessage({ 
        type: 'NAVIGATION_CHANGE',
        path: iframeWindow.location.href
      }, '*');
    });
  } catch (error) {
    console.error('Error injecting navigation listener:', error);
  }
};


export const sendEnvironmentInfo = (environment, additionalData = {}) => {
  try {
    const message = {
      type: 'ENVIRONMENT_INFO',
      environment: environment.toUpperCase(),
      timestamp: new Date().toISOString(),
      ...additionalData
    };

    window.parent.postMessage(message, '*');
    console.log('Environment info sentt:', message);
    console.log('my console');
  } catch (error) {
    console.error('Error sending environment info:', error);
  }
};


export const getCurrentEnvironment = () => {
  const hostname = window.location.hostname;

  if (hostname.includes('localhost')  || hostname.includes('dev') || hostname.includes('127.0.0.1')) {
    return 'DEV';
  } else if (hostname.includes('qa') || hostname.includes('staging') || hostname.includes('webapp-04') || hostname.includes('bnlwe-af01-q')) {
    return 'QA';
  } else if (hostname.includes('prod') || hostname.includes('production')) {
    return 'PROD';
  }
  
  return 'UNKNOWN';
};

export const sendLoginInfo = (userInfo, additionalData = {}) => {
  try {
    const message = {
      type: 'LOGIN_INFO',
      userInfo: {
        name: userInfo?.name,
        username: userInfo?.username,
        email: userInfo?.email,
        roles: userInfo?.roles,
      },
      timestamp: new Date().toISOString(),
      ...additionalData
    };

    window.parent.postMessage(message, '*');
    console.log('Login info sent:', message);
  } catch (error) {
    console.error('Error sending login info:', error);
  }
};

export const setupLogoutHandler = (logoutFunction) => {
  window.handleLogout = async () => {
    try {
      await logoutFunction();
      // Send logout confirmation to external app
      window.parent.postMessage({
        type: 'LOGOUT_CONFIRMATION',
        timestamp: new Date().toISOString()
      }, '*');
    } catch (error) {
      console.error('Error during logout:', error);
    }
  };
}; 